import styled from 'styled-components';
import { breakpoints } from '@theme/breakpoints';

export const StyledSearchBanner = styled.div<any>`
  .search-banner {
    background: rgb(204, 203, 254);
    background: linear-gradient(90deg, rgba(204, 203, 254, 1) 0%, rgba(251, 206, 210, 1) 100%);

    &__content {
      padding-top: 2rem;
      padding-bottom: 2rem;
      position: relative;
      z-index: 1;
      display: flex;
      flex-direction: column;
      gap: 2rem;
      justify-content: space-between;
      align-items: center;

      @media ${breakpoints.tablet} {
        flex-direction: row;
      }
    }

    &__categories {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      gap: 1rem;

      @media ${breakpoints.tablet} {
        justify-content: flex-start;
      }

      p {
        font-weight: 600;
        color: var(--color-black);
        padding-right: 1rem;
      }

      &__cats {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-evenly;
        gap: 1rem;

        @media ${breakpoints.tablet} {
          justify-content: flex-start;
        }
      }
    }

    &__category {
      border-radius: 10rem;
      -webkit-appearance: none;
      -webkit-box-shadow: 0px 5px 9px 5px rgba(124, 146, 213, 0.32);
      -moz-box-shadow: 0px 5px 9px 5px rgba(124, 146, 213, 0.32);
      box-shadow: 0px 5px 9px 5px rgba(124, 146, 213, 0.32);
      transition: transform 0.2s ease-in-out;

      &:hover {
        transform: translateY(-5px);
      }

      &.active {
        small {
          color: var(--color-primary);
        }
        transform: scale(1.1);
      }
    }

    &__search {
      min-width: 300px;
      position: relative;

      input {
        width: 100%;
        padding: 0.5rem 1rem;
        border-radius: 8px;
        -webkit-appearance: none;
        -webkit-box-shadow: inset 0px 0px 4px 0px rgba(173, 169, 251, 1);
        -moz-box-shadow: inset 0px 0px 4px 0px rgba(173, 169, 251, 1);
        box-shadow: inset 0px 0px 4px 0px rgba(173, 169, 251, 1);

        &::placeholder {
          color: var(--color-black);
        }

        &:focus-visible,
        &:active,
        &:focus {
          outline: none;

          & + img {
            display: none;
          }
        }
      }

      img {
        position: absolute;
        right: 1rem;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
`;
